export default "__VITE_ASSET__BQCtDe9y__"